import LineOrange from "../../../common/LineOrange/LineOrange";
import styles from "../style.module.css";

export const TypesOfTransactions = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="text-center mb-5 mt-5">
            <h3>انواع معاملات گواهی سپرده کالایی</h3>
            <LineOrange />
            <div className="d-flex justify-content-between flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row">
              <div className="col-12 col-lg-6 mb-3">
                <div className={styles.type_box}>
                  <h5>معاملات پیوسته</h5>
                  <LineOrange />
                  <p className="mt-2">
                    اوراق خریداری شده قابلیت فروش دارند. دارنده اوراق در صورت
                    تمایل قادر است کالای مورد نظر را از انبار دریافت کند.
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className={styles.type_box}>
                  <h5>معاملات ناپیوسته</h5>
                  <LineOrange />
                  <p className="mt-2">
                    معاملات به صورت حراج تک قیمتی انجام می‌شود، اوراق خریداری
                    شده قابل فروش نیستند و شخص خریدار باید کالای مورد نظر را از
                    انبار تحویل بگیرد.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
